var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImportingBtnIconShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3845_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7754 0.472656C19.5557 0.167852 19.2035 0 18.7837 0C18.5866 0 18.3752 0.0371484 18.1557 0.110391L1.14677 5.78C0.559267 5.97582 0.154345 6.37602 0.0357906 6.87805C-0.0827641 7.38012 0.1004 7.91926 0.53833 8.3573C0.581142 8.40016 0.630361 8.43609 0.684189 8.46387L7.84517 12.1552L11.5366 19.3162C11.5643 19.37 11.6003 19.4192 11.6431 19.462C11.995 19.8139 12.4009 20 12.8169 20H12.817C13.447 20 13.9848 19.5607 14.2204 18.8536L19.8901 1.84473C20.0684 1.3098 20.0276 0.822539 19.7754 0.472656ZM1.1763 7.14738C1.19872 7.05234 1.32942 6.95441 1.51731 6.89176L17.6613 1.51043L8.16841 11.0033L1.31138 7.46871C1.2081 7.34801 1.15704 7.22895 1.1763 7.14738ZM13.1086 18.483C13.053 18.6499 12.9472 18.8281 12.817 18.8281C12.7381 18.8281 12.6348 18.7771 12.5317 18.6889L8.99704 11.8319L18.4902 2.33883L13.1086 18.483Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3845_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportingBtnIconShare);
export default __webpack_public_path__ + "static/media/importingBtnIconShare.bd4b3039051d0c3b72e1b722234b2471.svg";
export { ForwardRef as ReactComponent };